import { required, minLength } from "vuelidate/lib/validators";

/*
Password Validation Rules

Minimum length: 7 characters
At least 1 number
At least 1 special character
At least 1 uppercase letter
At least 1 lowercase letter
*/

const MINIMUM_LENGTH = 7;

const CONTAINS_A_NUMBER_REGEX = /\d/;

const SPECIAL_CHARACTERS_REGEX = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

const UPPERCASE_LETTER_REGEX = /[A-Z]/;

const LOWERCASE_LETTER_REGEX = /[a-z]/;

const Minimum_Length_Message = "Atleast 7 characters. ";
const Number_Message = "Atleast 1 Number. ";
const Special_Character_Message = "Atleast 1 Special Character. ";
const Uppercase_Letter_Message = "Atleast 1 Uppercase Letter. ";
const Lowercase_Letter_Message = "Atleast 1 Lowercase Letter";

const containsANumber = value => {
  return CONTAINS_A_NUMBER_REGEX.test(value);
};
const containsASpecialCharacter = value => {
  return SPECIAL_CHARACTERS_REGEX.test(value);
};

const containsAnUppercaseLetter = value => {
  return UPPERCASE_LETTER_REGEX.test(value);
};

const containsALowercaseLetter = value => {
  return LOWERCASE_LETTER_REGEX.test(value);
};

const passwordValidation = {
  required,
  minLength: minLength(MINIMUM_LENGTH),
  containsANumber,
  containsASpecialCharacter,
  containsAnUppercaseLetter,
  containsALowercaseLetter
};

const passwordValidationMixin = (
  passwordAttributeName,
  isInFormObject,
  formObjectName
) => ({
  passwordValidation,
  computed: {
    password() {
      if (!!isInFormObject) return this[formObjectName][passwordAttributeName];
      return this[passwordAttributeName];
    },
    minimumLengthWarning() {
      return !this.password || this.password.toString().length < MINIMUM_LENGTH
        ? Minimum_Length_Message
        : "";
    },
    numberWarning() {
      return !containsANumber(this.password) ? Number_Message : "";
    },
    specialCharacterWarning() {
      return !containsASpecialCharacter(this.password)
        ? Special_Character_Message
        : "";
    },
    uppercaseLetterWarning() {
      return !containsAnUppercaseLetter(this.password)
        ? Uppercase_Letter_Message
        : "";
    },
    lowercaseLetterWarning() {
      return !containsALowercaseLetter(this.password)
        ? Lowercase_Letter_Message
        : "";
    },
    invalidPasswordMessage() {
      return `Must have ${this.minimumLengthWarning}${this.numberWarning}${this.numberWarning}${this.specialCharacterWarning}${this.uppercaseLetterWarning}${this.lowercaseLetterWarning}`;
    }
  }
});

export default passwordValidationMixin;
